import { cn as e } from "../utils/index.js";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
//#region src/components/spinner.tsx
function r({ className: r, size: i = "sm", ...a }) {
	return /* @__PURE__ */ n("svg", {
		viewBox: "0 0 64 64",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		role: "status",
		"aria-label": "Loading",
		className: e("animate-spin", `${i === "sm" ? "size-4" : "size-12"}`, r),
		...a,
		children: [/* @__PURE__ */ t("path", {
			d: "M64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32ZM6.4 32C6.4 46.1385 17.8615 57.6 32 57.6C46.1385 57.6 57.6 46.1385 57.6 32C57.6 17.8615 46.1385 6.4 32 6.4C17.8615 6.4 6.4 17.8615 6.4 32Z",
			fill: "#1B1B1D",
			fillOpacity: "0.1"
		}), /* @__PURE__ */ t("path", {
			d: "M60.8 32C62.5673 32 64.0166 33.4362 63.8401 35.1947C63.5285 38.3011 62.7633 41.351 61.5641 44.2459C59.956 48.1283 57.5989 51.6559 54.6274 54.6274C51.6559 57.5989 48.1283 59.956 44.2459 61.5641C41.351 62.7633 38.3011 63.5285 35.1947 63.8401C33.4362 64.0166 32 62.5673 32 60.8C32 59.0327 33.4382 57.6206 35.1917 57.4003C37.4569 57.1156 39.6786 56.5286 41.7967 55.6513C44.9026 54.3648 47.7248 52.4791 50.1019 50.1019C52.4791 47.7248 54.3648 44.9026 55.6513 41.7967C56.5286 39.6786 57.1156 37.4569 57.4003 35.1917C57.6206 33.4382 59.0327 32 60.8 32Z",
			fill: "#23A482"
		})]
	});
}
//#endregion
export { r as Spinner };
